module.exports = __webpack_public_path__ + "static/media/header-nomen.f29dcab6.png";